// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"9c3495611fc6607fa5aa","5338":"2f12ff75872993133028"}[chunkId] + ".js";
};